export default "__VITE_ASSET__CAC_GYyY__"